module.exports = __webpack_public_path__ + "img/NL532.9e60e2da.png";